// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discountTitle[data-v-18c1d1c2]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
